import { c as _c } from "react/compiler-runtime";
import { useDashboardRouter } from "@/hooks/useDashboardRouter";

/**
 * Hover and focus handlers that prefetch `href` again. A link's viewport
 * prefetch expires after the router's 5 minute TTL, after which a click pays
 * the RSC round trip; refreshing on intent hides that fetch in the hover to
 * click gap. `null` disables it (org-less redirect stubs have nothing worth
 * warming).
 */
export function useRoutePrefetchIntent(href) {
  const $ = _c(3);
  const router = useDashboardRouter();
  let t0;
  if ($[0] !== href || $[1] !== router) {
    const prefetch = () => {
      if (href) {
        router.prefetch(href);
      }
    };
    t0 = {
      onMouseEnter: prefetch,
      onFocus: prefetch
    };
    $[0] = href;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}